import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { searchParamSet } from '../../../../actions/SearchSolutionActions';
import { isNullOrUndefinedOrEmpty } from '../../../../helpers/common';
import { propFunc, propNumber, propOneOfType, propStr, } from '../../../../helpers/custom-prop-types';
const SideMenuPrices = (props) => {
    const { gteValue, lteValue, setParam } = props;
    return (_jsxs("div", Object.assign({ className: 'side-menu' }, { children: [_jsx("h2", { children: "\u4E88\u7B97" }), _jsxs("div", Object.assign({ className: 'side-menu-main side-slide' }, { children: [_jsx("input", { className: 'select-area mr0', id: 'price_gte', max: '999', min: '1', onChange: setParam, placeholder: '300', step: '1', type: 'number', value: isNullOrUndefinedOrEmpty(gteValue) ? '' : gteValue.toString() }), _jsx("span", Object.assign({ className: 'mx05' }, { children: "\u301C" })), _jsx("input", { className: 'select-area', id: 'price_lte', max: '999', min: '1', onChange: setParam, placeholder: '800', step: '1', type: 'number', value: isNullOrUndefinedOrEmpty(lteValue) ? '' : lteValue.toString() }), _jsx("span", { children: "\u4E07\u5186" })] }))] })));
};
SideMenuPrices.propTypes = {
    gteValue: propOneOfType([propStr, propNumber]),
    lteValue: propOneOfType([propStr, propNumber]),
    setParam: propFunc().isRequired,
};
SideMenuPrices.defaultProps = {
    gteValue: undefined,
    lteValue: undefined,
};
const mapStateToProps = ({ searchSolution }) => {
    const params = searchSolution.params || {};
    return {
        gteValue: params.price_gte,
        lteValue: params.price_lte,
    };
};
const mapDispatchToProps = (dispatch) => ({
    setParam: (e) => {
        const { target } = e;
        dispatch(searchParamSet({
            [target.id]: target.value,
        }));
    },
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(SideMenuPrices);
